import { getUrls } from '@shared/utils/config/environment';
export default async function signMessageWithActionWrapper({
  type,
  authMethods,
  pkp,
  baseUrl = '/api/wrapper?target=',
  network,
  environment,
  message
}) {
  const geniusExecutorEngineUrl = baseUrl + getUrls(environment).EXECUTOR_URL;
  const url = geniusExecutorEngineUrl + '/api/lit/sign-message-with-action';
  try {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        type,
        authMethods,
        pkp,
        network,
        environment,
        message
      })
    });
    const data = await response.json();
    return data;
  } catch (e) {
    console.error('[signMessageWithActionWrapper]', e);
    return null;
  }
}